import React, { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { Badge, Skeleton } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import Wrapper from './style';
import ClickOutside from '../clickOut';
import { GET_ME_USERS } from '../../graphql/queries/users';
import { AuthService } from '../../services';
import MenuHeaderComponent from './menuHeaderComponent';
import NotificationComponent from './notificationComponent';
import SwitchAccountComponent from './switchAccountComponent';
import AccountCard from '../accountCard';
import {
  GET_LIST_NOTIFICATIONS,
  GET_LIST_TEAM_AND_ROLE_BY_USER,
} from '../../graphql/queries';
import { MARK_ALL_NOTIFICATION_READ } from '../../graphql/mutations';
import { DocumentsHooks } from '../../hooks';

const LoadingFetching = () => {
  return (
    <div className="component_pageHeader_user_skeleton">
      <div>
        <Skeleton.Button active />
        <Skeleton.Button active />
      </div>
      <div>
        <Skeleton.Avatar size={44} active />
      </div>
    </div>
  );
};

const Index = (props) => {
  const { title, description, breadcrumb, loading } = props;
  const [showNotification, setShowNotification] = useState(false);
  const [showSwitchAccount, setShowSwitchAccount] = useState(false);

  const users = AuthService.getUserData();
  const defaultTeam = users?.default_team_id;
  const selectedTeam = users?.team?.id;
  const { data, loading: isLoading } = useQuery(GET_ME_USERS);
  const userData = data?.me || {};

  const {
    data: listUserTeams,
    loading: isLoadingTeam,
    refetch: refetchListTeams,
  } = useQuery(GET_LIST_TEAM_AND_ROLE_BY_USER, {
    variables: {
      limit: 100,
      offset: 0,
      where: {
        deleted_at: null,
        user_id: users.id,
        '$team.type$': 2,
      },
      sort: {
        created_at: 'DESC',
      },
    },
    skip: JSON.stringify(users) === '{}',
  });

  const { data: listOfNotifications, refetch } = useQuery(
    GET_LIST_NOTIFICATIONS,
    {
      variables: {
        limit: 10,
        offset: 0,
        where: {
          deleted_at: null,
          user_id: users.id,
        },
        sort: { created_at: 'DESC' },
      },
    }
  );

  const onRefetchTeams = () => {
    refetchListTeams();
  };

  const notificationList = listOfNotifications?.GetNotificationList?.data || [];
  const totalData =
    listOfNotifications?.GetNotificationList?.data?.filter((notification) => {
      return notification.read_status === 1;
    }).length || 0;

  const teamList = listUserTeams?.GetTeamMemberList?.data || [];
  const filterTeamList = teamList?.filter((item) => {
    return item?.id !== defaultTeam;
  });

  const selectedTeamData = teamList?.find((item) => {
    return item?.team_id === selectedTeam;
  });

  const [markAllRead] = useMutation(MARK_ALL_NOTIFICATION_READ, {
    onCompleted: () => {
      refetch();
    },
  });

  const onClickReadAllNotifications = () => {
    markAllRead();
  };

  const profileDocument = () => {
    if (selectedTeam === defaultTeam) {
      return userData?.profile_pic_document || {};
    }
    return selectedTeam?.team?.profile_pic_document || {};
  };

  const { url: profileUrl } = DocumentsHooks.useGetImageDocument(
    profileDocument()
  );

  return (
    <Wrapper>
      <MenuHeaderComponent
        breadcrumb={breadcrumb}
        title={title}
        description={loading ? '' : description}
      />

      {(isLoading || isLoadingTeam) && <LoadingFetching />}

      {!isLoading && !isLoadingTeam && (
        <div className="component_pageHeader_user">
          <ClickOutside
            onClickOutside={() => {
              setShowNotification(false);
            }}
          >
            <NotificationComponent
              isShow={showNotification}
              notificationList={notificationList}
              onClickReadAllNotifications={onClickReadAllNotifications}
            />
          </ClickOutside>
          <ClickOutside
            onClickOutside={() => {
              setShowSwitchAccount(false);
            }}
          >
            <SwitchAccountComponent
              isShow={showSwitchAccount}
              userData={userData}
              defaultTeam={defaultTeam}
              selectedTeam={selectedTeam}
              teamList={filterTeamList}
            />
          </ClickOutside>
          <span className="component_pageHeader_user_bell_icon">
            <Badge
              dot={totalData > 0}
              onClick={() => {
                setShowNotification(true);
              }}
            >
              <BellOutlined />
            </Badge>
          </span>
          <span
            className="component_pageHeader_user_information_wrapper"
            aria-hidden="true"
            onClick={() => {
              setShowSwitchAccount(true);
            }}
          >
            {selectedTeam === defaultTeam ? (
              <AccountCard
                name={userData?.name}
                description={userData?.email}
                onClick={onRefetchTeams}
                srcAvatar={profileUrl}
              />
            ) : (
              <AccountCard
                name={selectedTeamData?.team?.name}
                description={`as ${selectedTeamData?.role?.name}`}
                onClick={onRefetchTeams}
                srcAvatar={profileUrl}
              />
            )}
          </span>
        </div>
      )}
    </Wrapper>
  );
};

export default Index;
